<template>
  <div class="settle-manage-list" v-loading="loadingPage">
    <div class="header">
      <div class="title">结算管理</div>
      <div class="search">
        <el-form inline class="inline-form" :model="searchForm" label-width="85px" label-position="left">
          <el-form-item label="结算时间">
            <el-date-picker
              v-model="comtime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结算单号">
            <el-input v-model="searchForm.settleNo" placeholder="请输入结算单号" size="small"></el-input>
          </el-form-item>
          <el-form-item label="结算商户" style="margin-left: 30px">
           <el-select v-model="searchForm.merchantIdSelect" placeholder="请选择" clearable>
            <el-option
              v-for="item in merchantList"
              :key="item.merchantId"
              :label="item.merchantName"
              :value="item.merchantId">
            </el-option>
          </el-select>
          </el-form-item>
          <!-- .saas大客的下属门店可以选择单独结算，连锁大客不显示结算门店筛选项； -->
          <el-form-item label="结算门店">
            <el-select v-model="searchForm.shopNoSelect" placeholder="请选择" clearable>
              <el-option
                v-for="item in shopList"
                :key="item.shopNo"
                :label="item.shopName"
                :value="item.shopNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态">
            <el-select v-model="searchForm.settleState" clearable placeholder="请选择">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="search" class="btnBase searchBtn">查询</el-button>
        </el-form>
      </div>
    </div>
    <div class="table-list">
      <div class="summary">
        <div class="item">
          <span>{{isShowToday?'今日结算笔数':'结算笔数'}}</span>
          ：{{listResultEntity.todaySettleNum}}笔</div>
        <div class="item">结算商户：{{listResultEntity.settleMerchantNum}}个</div>
        <div class="item">结算门店：{{listResultEntity.settleShopNum}}个</div>
        <div class="item">结算成功：{{listResultEntity.settleSuccess}}笔</div>
        <div class="item">结算失败：{{listResultEntity.settleFail}}笔</div>
        <div class="item">结算金额：{{listResultEntity.settleAmount}}元</div>
      </div>
      <div class="tabledata-con">
        <el-table :data="listResultEntity.settleDetailList" style="width: 100%" border v-loading="loadingTable">
          <el-table-column prop="settleTime" label="结算时间" align="center"></el-table-column>
          <el-table-column prop="settleNo" label="结算单号" align="center"> </el-table-column>
          <!-- 连锁大客该字段为结算商户，saas大客该字段为结算商户/门店； -->
          <el-table-column prop="merchant" label="结算商户/门店" align="center"> </el-table-column>
          <el-table-column prop="settleAmount" label="结算金额" align="center"> </el-table-column>
          <el-table-column prop="settleMethod" label="结算方式" align="center"> </el-table-column>
          <el-table-column prop="receiveAccount" label="收款账户" align="center"> </el-table-column>
          <el-table-column prop="settleStatus" label="结算状态" align="center"> </el-table-column>
          <el-table-column prop="settleRemark" label="备注" align="center"> </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination v-if="page.count > 0" class="pagination"
            prev-text="上一页" next-text="下一页" :page-size="page.pageSize" layout="total, prev, pager, next, jumper"
            :total="page.count" :current-page="page.pageNo" @current-change="onChangeCurrentPage">
          </el-pagination>
        </el-col>
      </div>
    </div>
  </div>
</template>
<script>
import { querySettleList, queryMerchantList, queryShopList } from "@/api/settle";
import { formatDate, getTodayStartTimestamp, getTodayEndTimestamp } from '@/utils/index';

export default {
  data() {
    return {
      comtime: [formatDate(getTodayStartTimestamp()), formatDate(getTodayEndTimestamp())],
      searchForm: {
        shopNoSelect: "",
        merchantIdSelect: "",
        startTime: formatDate(getTodayStartTimestamp()),
        endTime: formatDate(getTodayEndTimestamp()),
        settleNo: '',
        settleState: '',
        merchantId: JSON.parse(window.localStorage.getItem('LOGIN_INFO')).merchantId,
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      listResultEntity: {
        todaySettleNum: '',
        settleMerchantNum: '',
        settleShopNum: '',
        settleSuccess: '',
        settleFail: '',
        settleAmount: '',
        settleTotal: '',
        settleDetailList: [],
      },
      statusList: [
        { label: '结算成功', value: 1 },
        { label: '结算失败', value: -1 },
        { label: '结算中', value: 0 },
        { label: '打款冻结', value: 3 },
      ],
      loadingTable: false,
      loadingPage: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      merchantList: [],
      shopList: [],
      isMerchant: true,
      isShowToday: true,
    };
  },
  watch: {
    searchForm: {
      handler(newVal, oldVal) {
        // 判断是否结算门店先选
        if (oldVal.merchantIdSelect === '' && oldVal.shopNoSelect !== '') {
          this.isMerchant = false;
        }
        // 判断是否结算商户先选
        if (oldVal.merchantIdSelect !== '' && oldVal.shopNoSelect === '') {
          this.isMerchant = true;
        }
        // 结算门店和结算商户互斥
        if (oldVal.merchantIdSelect !== '' && oldVal.shopNoSelect !== '') {
          // 根据先选判断清空哪个筛选条件
          if (this.isMerchant) {
            this.searchForm.shopNoSelect = '';
          } else {
            this.searchForm.merchantIdSelect = '';
          }
          this.$message({
            message: '结算商户和结算门店只能选其一',
            type: 'warning',
          });
        }
      },
      deep: true,
    },
    comtime(val) {
      if (val) {
        this.searchForm.startTime = formatDate(val[0]);
        this.searchForm.endTime = formatDate(val[1]);
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
    },
  },
  methods: {
    search() {
      this.page.pageNo = 1;
      this.isToday();
      this.querySettleList();
    },
    isToday() {
      const date = formatDate(new Date());
      if (this.searchForm.startTime === date && this.searchForm.endTime === date) {
        this.isShowToday = true;
      } else {
        this.isShowToday = false;
      }
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.querySettleList();
    },
    methodToString(e) {
      switch (e) {
        case '0':
          return '非法人结算卡(对私)';
        case '1':
          return '法人(对私)';
        case '2':
          return '对公';
        default:
          return '非法人结算卡(对私)';
      }
    },
    statusToString(e) {
      switch (e) {
        case '-1':
          return '结算失败';
        case '0':
          return '结算中';
        case '1':
          return '结算成功';
        case '2':
          return '打款冻结';
        default:
          return '结算中';
      }
    },
    // 获取结算列表
    querySettleList() {
      const params = Object.assign(this.searchForm, this.page);

      // 如果日期为空，不能查询
      if (!params.startTime) {
        this.$message({
          message: '查询日期必传',
          type: 'error',
        });
        return;
      }
      this.loadingPage = true;
      const loginInfo = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
      params.merchantId = loginInfo.merchantId;
      querySettleList(params).then((res) => {
        this.loadingPage = false;
        if (res.data.error_code === 0) {
          this.listResultEntity = res.data.data;
          this.page.count = res.data.data.settleTotal;
          if (this.listResultEntity) {
            this.listResultEntity.settleAmount = (this.listResultEntity.settleAmount / 100).toFixed(2);
          }
          if (this.listResultEntity.settleDetailList) {
            this.listResultEntity.settleDetailList.forEach((e) => {
              // eslint-disable-next-line
              e.merchant = e.merchantName + "\n" + e.merchantId;
              // eslint-disable-next-line
              e.receiveAccount = e.receiveAccountList.userName + "\n" + e.receiveAccountList.bankName + "\n" + e.receiveAccountList.cardNo;
              e.settleAmount = (e.settleAmount / 100).toFixed(2);
              e.settleStatus = this.statusToString(e.settleState);
              e.settleMethod = this.methodToString(e.settleMethod);
            });
          }
        }
      }).catch(() => {
        this.loadingPage = false;
      });
    },
    queryMerchantList() {
      const loginInfo = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
      queryMerchantList({
        merchantId: loginInfo.merchantId,
        pageType: 0, // 0-结算页面；1-收益明细页面
      }).then((res) => {
        if (res.data.error_code === 0) {
          this.merchantList = res.data.data;
        }
      });
    },
    queryShopList() {
      const loginInfo = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
      queryShopList({
        merchantId: loginInfo.merchantId,
        pageType: 0, // 0-结算页面；1-收益明细页面
      }).then((res) => {
        if (res.data.error_code === 0) {
          this.shopList = res.data.data;
        }
      });
    },
  },
  created() {
    this.querySettleList();
    this.queryMerchantList();
    this.queryShopList();
  },
};
</script>
<style lang="scss">
.settle-manage-list {
  .btnBase{
    height: 32px;
    margin-top: 5px;
    line-height: 0px;
  }
  background-color: #f7f7f7;
  .paginationBox {
    text-align: center;
  }
  > .header {
    .search{
      margin-top: 40px;
      // margin-bottom: 20px;
    }
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
    .el-range-separator {
      width: 20px;
    }
  }
  .table-list {
    background: #f7f7f7;
    overflow: hidden;
    .summary {
      border-top: 20px solid #eee;
      display: flex;
      align-items: center;
      width: 100%;
      background-color: #FAFAFA;
      padding-left: 50px;
      height: 80px;
      .item {
        margin-right: 40px;
      }
    }
    .tabledata-con {
      padding: 10px 50px 40px 50px;
      background: #fff;
      overflow: hidden;
      .el-table .cell {
        white-space: pre-line;
      }
      .table-btn {
        margin-right: 10px;
        cursor: pointer;
        color: #ff9c00;
      }
    }
  }
}
</style>
